module.exports = __webpack_public_path__ + "Logo_Dark Green White Text-e657be5989d374a3204540375e835710.svg";